import { Alert, Flex } from 'antd';
import { Text } from 'components/mvp-typography';
import { UseErrorListReturn } from 'lib/utils/useErrorList';
import { ReactNode } from 'react';

export function ErrorDisplay(props: {
  error: { message: string; cause?: unknown | string };
  title?: string;
  description?: string | ReactNode;
  style?: React.CSSProperties;
  closeable?: boolean;
  onClose?: () => void;
}) {
  return (
    <Alert
      type="error"
      message={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}
        >
          <div>
            <Text style={{ fontWeight: 'bold' }}>{props.title}</Text>
            <Text>{props.description}</Text>
          </div>
          <code
            style={{
              background: 'white',
              padding: '1rem',
              color: 'var(--ant-color-error)',
              gap: 12
            }}
          >
            {props.error.message}
            <br />
            {props.error.cause}
          </code>
        </div>
      }
      closable={props.closeable}
      onClose={props.onClose}
    />
  );
}

export function ErrorListDisplay(props: {
  errorList: UseErrorListReturn;
  closeable?: boolean;
  onClose?: () => void;
}) {
  return (
    <Flex vertical gap={4}>
      {props.errorList.errors.map(error => (
        <ErrorDisplay
          key={error.id}
          error={error.error}
          title={error.title}
          description={''}
          closeable={props.closeable}
          onClose={() => {
            props.onClose?.();
            props.errorList.removeError(error.id);
          }}
        />
      ))}
    </Flex>
  );
}
